

// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, whiteSidenav, miniSidenav, darkMode } = ownerState;

  const sidebarWidth = 248;
  const { transparent, white } = palette;
  const { md } = boxShadows;
  const { pxToRem } = functions;

  const sidenavBg = "#0E2348";
  let backgroundValue = sidenavBg;

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  const drawerOpenStyles = () => ({
    background: backgroundValue,
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      boxShadow: transparentSidenav ? "none" : md,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  const drawerCloseStyles = () => ({
    background: backgroundValue,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      boxShadow: transparentSidenav ? "none" : md,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: pxToRem(80),
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      boxShadow: md,
      border: `1px solid ${transparentSidenav || whiteSidenav ? (palette.outline?.variant || "rgba(17,42,82,.08)") : "rgba(255,255,255,0.08)"}`,
      borderRadius: pxToRem(16),
      margin: pxToRem(12),
      height: `calc(100% - ${pxToRem(24)})`,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",

      "&::-webkit-scrollbar": {
        width: "4px",
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
      },
      "&::-webkit-scrollbar-thumb": {
        background: transparentSidenav
          ? "rgba(255, 255, 255, 0.06)"
          : whiteSidenav
            ? "rgba(17, 42, 82, 0.1)"
            : "rgba(255, 255, 255, 0.08)",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: transparentSidenav
          ? "rgba(255, 255, 255, 0.14)"
          : whiteSidenav
            ? "rgba(17, 42, 82, 0.18)"
            : "rgba(255, 255, 255, 0.16)",
      },
      scrollbarWidth: "thin",
      scrollbarColor: transparentSidenav
        ? "rgba(255, 255, 255, 0.06) transparent"
        : whiteSidenav
          ? "rgba(17, 42, 82, 0.1) transparent"
          : "rgba(255, 255, 255, 0.08) transparent",

      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
